import React from 'react'
import { CommonModal } from '../../../AbstractElements'
import { Row, Col } from "reactstrap";
import { showAlert } from '../../../Services/Shared.service';
import { DeleteVendor } from '../../../Services/Ventor.service';


const DeleteConfirmationModal = ({ Large, title, LargeModaltoggle, driverObj, fetchData}) => {
 
 
    const onDeleteSubmit = () => {
   DeleteVendor(driverObj.id).then(async (result) => {
            showAlert('success', "Vendor Deleted successfully")
            await fetchData()
            LargeModaltoggle();

        }).catch(err => {
            showAlert('error', err.response?.data?.message
                ? err.response.data.message : 'Something went wrong')
        })
    };
 
    return (
    <CommonModal
    isOpen={Large}
    title={title}
    toggler={LargeModaltoggle}
    size="md"
>
    <Row className="driver-push-notification">
        <Col xl="12" className="push-botification-body">
            <div className="text-center">Are you sure you want to delete this Vendor ?</div>
        </Col>
        <Col xl="12" className="push-notification-footer">
            <button
                className="btn btn-primary"
                type="submit"
                onClick={() => onDeleteSubmit()}
            >
                Confirm
            </button>
        </Col>
    </Row>
</CommonModal>
  )
}

export default DeleteConfirmationModal